module.exports = __webpack_public_path__ + "static/img/back_mobile.73c82617.jpg";